import { useSearchStore } from '../stores/searchStore'
import SearchResultCard from './SearchResultCard'

export default function SearchResults() {
  const { query, results, total, loading, error, search, loadMore } = useSearchStore()

  if (!query) return null

  if (loading && results.length === 0) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="w-6 h-6 border-2 border-accent border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  if (error && results.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <p className="text-error text-sm mb-4">{error}</p>
        <button
          onClick={() => search(query)}
          className="px-4 py-2 rounded-lg bg-elevated text-text-secondary text-sm font-medium hover:bg-bg transition-colors"
        >
          Try again
        </button>
      </div>
    )
  }

  if (results.length === 0) {
    return (
      <div className="flex flex-col items-center py-8 text-center">
        <svg className="w-16 h-16 text-text-muted opacity-30 mb-4" fill="none" viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
        </svg>
        <p className="text-text-secondary text-sm">No results for &ldquo;{query}&rdquo;</p>
      </div>
    )
  }

  return (
    <div className="space-y-2">
      <p className="text-xs text-text-secondary">
        {total} result{total !== 1 ? 's' : ''}
      </p>
      {results.map((result, i) => (
        <SearchResultCard key={`${result.entry_id}-${i}`} result={result} />
      ))}
      {results.length < total && (
        <button
          onClick={loadMore}
          disabled={loading}
          className="w-full py-2 text-sm text-accent hover:text-accent-hover disabled:opacity-50"
        >
          {loading ? 'Loading...' : 'Load more'}
        </button>
      )}
    </div>
  )
}
